import { State } from './types';

export const catalogState: State = {
  catalog: [],
  lastPositionId: '',
};
